import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function BatteryFull(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props} viewBox='0 0 12 12'>
      <path
        d='M8.52575 0.846691H7.95432C7.89558 0.846691 7.84751 0.798627 7.84751 0.739882V0.104368C7.84751 0.0456227 7.79945 -0.00244141 7.7407 -0.00244141H4.26407C4.20532 -0.00244141 4.15726 0.0456227 4.15726 0.104368V0.739882C4.15726 0.798627 4.10919 0.846691 4.05045 0.846691H3.47902C3.14791 0.846691 2.88623 1.11371 2.88623 1.43948V11.4795C2.88623 11.7679 3.12121 11.9976 3.40425 11.9976H8.60586C8.89424 11.9976 9.12388 11.7626 9.12388 11.4795V1.43948C9.12388 1.10837 8.85686 0.846691 8.53109 0.846691H8.52575ZM8.35486 11.0363C8.35486 11.095 8.30679 11.1431 8.24805 11.1431H5.99972H3.75138C3.69264 11.1431 3.64457 11.095 3.64457 11.0363V1.81865C3.64457 1.75991 3.69264 1.71184 3.75138 1.71184H5.99705H8.24271C8.30145 1.71184 8.34951 1.75991 8.34951 1.81865V11.0363H8.35486Z'
        fill='currentColor'
      />
      <rect
        x='4'
        y='9.2002'
        width='4'
        height='1.5'
        rx='0.05'
        fill='currentColor'
      />
      <rect x='4' y='2' width='4' height='1.5' rx='0.05' fill='currentColor' />
      <rect
        x='4'
        y='3.7998'
        width='4'
        height='1.5'
        rx='0.05'
        fill='currentColor'
      />
      <rect
        x='4'
        y='5.6001'
        width='4'
        height='1.5'
        rx='0.05'
        fill='currentColor'
      />
      <rect
        x='4'
        y='7.3999'
        width='4'
        height='1.5'
        rx='0.05'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
}
